package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.theme.Typography
import net.frozenbit.games.soundgame.theme.icons.play_circle
import net.frozenbit.games.soundgame.viewmodels.ControllerViewModel

@Composable
fun ControllerVotingScreen(
    options: List<ControllerViewModel.ControllerUiState.Voting.VoteOption>,
    onVoteSelected: (Int) -> Unit,
    onReplayClicked: (Int) -> Unit,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(16.dp, Alignment.Top),
        modifier = Modifier
            .fillMaxSize()
            .padding(8.dp)
    ) {
        Text(
            "Wähle den Sound, der dir am besten gefällt",
            fontSize = Typography.Controller.title,
        )
        options.forEachIndexed { index, option ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Button(
                    modifier = Modifier
                        .weight(1f),
                    onClick = { onVoteSelected(index) },
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(4.dp),
                    ) {
                        Text(
                            option.line1,
                            fontSize = Typography.Controller.body,
                        )
                        HorizontalDivider()
                        Text(
                            option.line2,
                            fontSize = Typography.Controller.body,
                        )
                    }
                }
                Button(
                    modifier = Modifier
                        .padding(start = 8.dp),
                    onClick = { onReplayClicked(index) },
                ) {
                    Icon(
                        imageVector = play_circle,
                        contentDescription = null,
                    )
                }
            }
        }
    }
}